// autogenerated
export * from './GuiObject';
